import { Button, mergeClasses } from "@fluentui/react-components";
import { useStyles } from "./style";
import { Checkmark32Regular } from "@fluentui/react-icons";
import { InteractionButtonProps } from "./types";
import { useIntl } from "react-intl";

export const AcceptInteractionButton = (props: InteractionButtonProps) => {
	const intl = useIntl();
	const { onClick } = props;
	const style = useStyles();

	return (
		<Button
			className={mergeClasses(style.acceptButton, style.button)}
			icon={<Checkmark32Regular />}
			title={intl.formatMessage({ id: "Interaction.Buttons.Accept" })}
			onClick={onClick}
		/>
	);
};
